// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BnMoJ1cBvssJo5iajQ2h{color:var(--content-negative-primary)}.zfjbgCbjgIeao9l6Z74Y{gap:0;display:flex}.zfjbgCbjgIeao9l6Z74Y>div{background:var(--background-primary-inverted-primary)}.zfjbgCbjgIeao9l6Z74Y>div:nth-child(2){z-index:var(--zIndex-BASE_2);border-radius:50%;margin-left:-6px;box-shadow:0 0 0 1.5px #fff}.zfjbgCbjgIeao9l6Z74Y>div:nth-child(3){z-index:var(--zIndex-BASE_3);border-radius:50%;margin-left:-6px;box-shadow:0 0 0 1.5px #fff}.zfjbgCbjgIeao9l6Z74Y>div:nth-child(n+4){display:none}.Rr9_jakxofJoec9npP84{align-items:center;gap:8px;height:32px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"warning": `BnMoJ1cBvssJo5iajQ2h`,
	"group": `zfjbgCbjgIeao9l6Z74Y`,
	"box": `Rr9_jakxofJoec9npP84`
};
export default ___CSS_LOADER_EXPORT___;
